module.exports = __webpack_public_path__ + "8a31732bd6c3f405230519a9a6effeb0.svg";